<template>
<div>

    <div>
      <HeaderAdmin/>
    </div>

    <div class="container top">
      <div class="row">

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-primary shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">SENSOR CONNECTED</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">{{ AllApplication.length | numFormat  }}</div>
                    </div>
                    <div class="col-auto">
                      <i class="fa fa-plug fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Earnings (Annual) Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-danger shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">ALARM</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">10</div>
                    </div>
                    <div class="col-auto">
                      <i class="fa fa-exclamation-triangle fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

           

            <!-- Pending Requests Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-warning shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">USER</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">{{ AllUser.length | numFormat  }}</div>
                    </div>
                    <div class="col-auto">
                      <i class="fa fa-users fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-success shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">DATA RECEIVED</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">{{ AllDevice.length | numFormat  }}</div>
                     

                    </div>
                    <div class="col-auto">
                      
                       <vue-json-to-csv :json-data='AllDevice'
                            :labels="{ appname: { title: 'Nama Sensor' }, level: { title: 'Ketinggian Air' }, update_on: { title: 'Waktu Receive'} , batt: { title: 'Battery'} }"
                             >
                            <button class="btn btn-success">
                           <i class="fa fa-database fa-2x text-gray-300"></i>
                          </button>
                          </vue-json-to-csv>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row">

              <div class="col-lg-12 pb-4">
                  <Map/>
              </div>    
          </div>    

          <!-- <div class="row">

            <div class="col-lg-6">

              <SensorCard/>
            
            </div>

            <div class="col-lg-6">

              <SensorData/>
            
            </div>

          </div> -->
  
  
      </div>
  </div>
</template>

<script>

// @ is an alias to /src
import VueJsonToCsv from 'vue-json-to-csv'
import HeaderAdmin from '@/components/HeaderAdmin.vue'
// import SensorCard from '@/components/Sensor/SensorCard.vue'
// import SensorData from '@/components/Sensor/SensorData.vue'
import Map from '@/components/Map/Map.vue'


export default {
    name: 'Admin',
      components: {
        HeaderAdmin, Map, VueJsonToCsv
        // SensorCard, SensorData
      },

    computed:{
      user(){
        return this.$store.getters.user
      },
      AllApplication() {
            return this.$store.getters.AllApplication
        },
      AllDevice() {
            return this.$store.getters.AllDevice
        }, 
        
      AllUser() {
            return this.$store.getters.AllUser
        },   
    },
    
      mounted(){
        this.$store.dispatch('getApplication')
        // this.$store.dispatch('getDeviceLimit')
        this.$store.dispatch('getDevice')
        this.$store.dispatch('getUser')
      }
  
}
</script>

<style >

.container{
  padding-top: 80px;
}

</style>
